import React from "react";
import { Link } from "react-router-dom";
import {
	Grid,
	Typography,
	Breadcrumbs,
	Box
} from "@mui/material";
import DownloadATemplatePanel from "./views/DownloadATemplatePanel";
import UploadATemplatePanel from "./views/UploadATemplatePanel";
import SellerDependentView from "../Shared/SellerDependentView";
import PermissionDependentView from "../Shared/PermissionDependentView/PermissionDependentView";
import "./OrderUpload.scss";

export default function OrderUpload({ seller, userdata }) {

	const BreadCrumb = () => {
		return (
			<Box className="bread-crumb">
				<Breadcrumbs aria-label="breadcrumb">
					<Link underline="hover" color="inherit" to="/order-status">
						Orders
					</Link>
					<Typography color="text.primary">Order Upload</Typography>
				</Breadcrumbs>
			</Box>
		);
	};

	return (
		<Box id="order-upload">
			<PermissionDependentView userdata={userdata} permission="import_orders">
				<SellerDependentView seller={seller}>
					<Grid container>
						<Grid item xs={12} lg={12} mb={4}>
							<BreadCrumb />
						</Grid>
						<Grid item xs={12} lg={12} mb={4}>
							<DownloadATemplatePanel seller={seller} />
						</Grid>

						<Grid item xs={12} lg={12}>
							<UploadATemplatePanel seller={seller} />
						</Grid>
					</Grid>
				</SellerDependentView>
			</PermissionDependentView>
		</Box>
	);
}
